import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import $ from 'jquery';             window.$ = window.jQuery = $
import select2 from 'select2';      select2($); $('.select2').select2({ width:'100%', theme:'bootstrap-5' })
import Rails from '@rails/ujs';     Rails.start()

const pages = import.meta.glob('../pages/**/*.js')

document.addEventListener('DOMContentLoaded', () => {
  const controller = document.body.dataset.controller
  const action     = document.body.dataset.action
  if (!controller || !action) return

  const key = `../pages/${controller}/${action}.js`
  const loader = pages[key]

  if (loader) {
    loader().then(mod => {
      if (typeof mod.default === 'function') mod.default()
      else if (mod.init) mod.init()
    })
  } else {
    console.warn(`Página JS não encontrada: ${key}`)
  }
})
